import { AnimatePresence, MotionProps, motion } from "framer-motion";
import {
  Dialog,
  DialogProps,
  ModalOverlay,
  Modal as ModalRAC,
} from "react-aria-components";
import { cn } from "../../cn";

const MotionModalOverlay = motion(ModalOverlay);
const MotionModal = motion(ModalRAC);
const MotionDialog = motion(Dialog);

const variants = {
  enter: (direction: number) => {
    return {
      x: direction > 0 ? 1000 : -1000,
      opacity: 0,
    };
  },
  center: {
    x: 0,
    opacity: 1,
  },
  exit: (direction: number) => {
    return {
      x: direction < 0 ? 1000 : -1000,
      opacity: 0,
    };
  },
};

export default function ModalLayoutDialog({
  layoutId,
  close,
  containerClassName,
  dialogClassName,
  direction,
  onAnimationStart,
  onAnimationComplete,
  ...props
}: DialogProps &
  Omit<MotionProps, "layoutId"> & {
    layoutId?: string | number;
    close: () => void;
    containerClassName?: string;
    dialogClassName?: string;
    direction?: number;
  }) {
  if (!layoutId) return null;
  return (
    <MotionModalOverlay
      isOpen
      onOpenChange={close}
      className="fixed top-0 left-0 w-screen h-screen isolate z-20 bg-black-0/30 flex items-center justify-center backdrop-blur-sm"
      animate={{ opacity: 1 }}
      initial={{ opacity: 0 }}
      exit={{ opacity: 0 }}
      isDismissable
    >
      <AnimatePresence initial={false} custom={direction}>
        <MotionModal
          key={layoutId}
          custom={direction}
          variants={variants}
          initial="enter"
          animate="center"
          exit="exit"
          layoutId={`background-${layoutId}`}
          onAnimationStart={onAnimationStart}
          onAnimationComplete={onAnimationComplete}
          className={cn(
            "bg-white rounded-6 shadow-y-plus-5 absolute",
            containerClassName,
          )}
        >
          <MotionDialog
            className={cn("outline-hidden h-full", dialogClassName)}
            {...props}
          />
        </MotionModal>
      </AnimatePresence>
    </MotionModalOverlay>
  );
}
